import { createSlice } from '@reduxjs/toolkit';
import { MY_FLEET_STATE } from 'features/myFleet/constants';
import { MyFleetState } from 'features/myFleet/types';
import { setFilter } from './setFilter';
import { setSearchValue } from './setSearchValue';
import { setSortOrder } from './setSortOrder';
import { setActiveDisplay } from './setActiveDisplay';
import { setSelectCar } from './setSelectCar';
import { setSelectedMobileLocation } from './setSelectedMobileLocation';

const initialState: MyFleetState = {
  filter: {},
  sortOrder: 'default',
  searchValue: '',
  activeDisplay: 'carsList',
  selectedCar: null,
  selectedMobileLocation: null,
};

export const myFleetSlice = createSlice({
  name: MY_FLEET_STATE,
  initialState,
  reducers: {
    setFilter,
    setSearchValue,
    setSortOrder,
    setActiveDisplay,
    setSelectCar,
    setSelectedMobileLocation,
  },
});

export const myFleetActions = myFleetSlice.actions;
export const myFleetReducer = myFleetSlice.reducer;
